import {
    Clock3,
    PlusCircle,
    Pencil,
    Star,
    Flame,
    CheckCircle2,
} from "lucide-react";

import "./ActivityTab.css";

function ActivityTab({ food }) {

    const activities = [
        {
            icon: <PlusCircle size={18} />,
            title: "Food Created",
            subtitle: "Food item was added to the platform.",
            time: food.createdAt
                ? new Date(food.createdAt).toLocaleString()
                : "-",
        },
        {
            icon: <Pencil size={18} />,
            title: "Last Updated",
            subtitle: "Latest modification made by provider/admin.",
            time: food.updatedAt
                ? new Date(food.updatedAt).toLocaleString()
                : "-",
        },
        {
            icon: <CheckCircle2 size={18} />,
            title: food.isAvailable
                ? "Currently Available"
                : "Currently Unavailable",
            subtitle: "Current availability status.",
            time: "Current",
        },
        {
            icon: <Star size={18} />,
            title: food.isFeatured
                ? "Featured Food"
                : "Not Featured",
            subtitle: "Featured status.",
            time: "Current",
        },
        {
            icon: <Flame size={18} />,
            title: food.isBestSeller
                ? "Best Seller"
                : "Normal Food",
            subtitle: "Sales performance status.",
            time: "Current",
        },
    ];

    return (

        <div className="activity-tab">

            <div className="activity-timeline">

                {activities.map((activity, index) => (

                    <div
                        key={index}
                        className="activity-item"
                    >

                        <div className="activity-icon">

                            {activity.icon}

                        </div>

                        <div className="activity-content">

                            <h3>{activity.title}</h3>

                            <p>{activity.subtitle}</p>

                        </div>

                        <div className="activity-time">

                            <Clock3 size={16} />

                            <span>{activity.time}</span>

                        </div>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default ActivityTab;